import { locals as variables } from './antdVariables.less';
import { AntdVariableType, ColorNameType, SideType, ThemeType } from './types';

export { AntdVariableType, ColorNameType, SideType, ThemeType };

export const breakpoints = {
  xs: 360,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1600,
} as const;

const theme: ThemeType = {
  ...variables,
  getColor: colorName => {
    switch (colorName) {
      case 'primary':
      case 'success':
      case 'warning':
        return theme[`${colorName}Color` as AntdVariableType];
      case 'danger':
        return theme.errorColor;
      case 'answering':
        return '#ff9b94';
      case 'info':
        return theme.primaryColor;
      case 'textPrimary':
        return theme.textColor;
      case 'textSecondary':
        return theme.textColorSecondary;
      case 'background':
        return '#f0f2f5';
      case 'black':
      case 'white':
        return colorName;
      default:
        return theme[colorName as AntdVariableType];
    }
  },
  getElevation: side => {
    const {
      boxShadowHorLength,
      boxShadowVerLength,
      boxShadowBlur,
      boxShadowSpread,
      boxShadowColor: color,
      boxShadowBase,
    } = theme;

    const hor = Number(boxShadowHorLength);
    const ver = Number(boxShadowVerLength);
    const blur = Number(boxShadowBlur);
    const spread = Number(boxShadowSpread);

    const offset = Math.round((blur * 10) / 2) / 10;
    const newBlur = blur - offset;
    const newSpread = spread - offset;

    const arr: (string | undefined)[] = Array.isArray(side) ? side : [side];

    return arr
      .map(currSide => {
        let newHor = 0;
        let newVer = 0;

        switch (currSide) {
          case 'left':
            newHor = hor - newBlur;
            break;
          case 'right':
            newHor = hor + newBlur;
            break;
          case 'top':
            newVer = ver - newBlur;
            break;
          case 'bottom':
            newVer = ver + newBlur;
            break;
          default:
            return boxShadowBase;
        }

        return `${newHor}px ${newVer}px ${newBlur}px ${newSpread}px ${color}`;
      })
      .join(', ');
  },
  getBorderRadius: size => {
    switch (size) {
      case 'small':
        return '2px';
      case 'large':
        return '8px';
      default:
        return '4px';
    }
  },
};

export default theme;
